var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChinese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_21458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4759 10.4643L11.6972 14.2232H15.6496L12.4521 16.5464L13.6734 20.3054L10.4759 17.9822L7.27825 20.3054L8.49963 16.5464L5.302 14.2232H9.25444L10.4759 10.4643Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1745 22.9665L16.9753 22.0953L15.7763 22.9665L16.2342 21.5569L15.0352 20.6857H16.5174L16.9753 19.2761L17.4335 20.6857H18.9155L17.7165 21.5568L18.1745 22.9665Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3023 18.6609H19.8202L19.3621 20.0705L18.9042 18.661L17.4219 18.6609L18.6211 17.7897L18.1631 16.3802L19.3622 17.2512L20.5613 16.3801L20.1032 17.7897L21.3023 18.6609Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3017 13.339L20.1026 14.2103L20.5606 15.6197L19.3616 14.7487L18.1624 15.6199L18.6205 14.2102L17.4214 13.339L18.9036 13.339L19.3616 11.9293L19.8196 13.339L21.3017 13.339Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1735 9.03345L17.7156 10.4431L18.9146 11.3143L17.4326 11.3143L16.9744 12.7241L16.5164 11.3143L15.0343 11.3144L16.2334 10.4431L15.7753 9.03339L16.9743 9.9047L18.1735 9.03345Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_21458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinese);
export default __webpack_public_path__ + "static/media/Chinese.2eed5741f6e201601e6da78ebebea0bc.svg";
export { ForwardRef as ReactComponent };